// @flow

export const entityTypes = {
  COURSE: "course",
  EVENT: "event",
};
